import { Passport } from './Passport'

if (typeof window !== 'undefined') {
  window.CredenzaPassport = Passport
}

export { Passport }
